import styles from './styles.module.css'

const Loader = () => <div className={styles.loader}></div>

export default Loader